import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { delay } from 'rxjs/internal/operators';
import {User} from "./modele/user/userModel";
import {UserSettings} from "./modele/user/userSettings";
import {EndpointService} from "./services/endpoint/endpoint.service";
import {UserService} from "./services/user.service";
import {NGXLogger} from "ngx-logger";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private log_prefix = this.constructor.name;
  constructor(private endpointService: EndpointService,
              private userService: UserService,
              private logger: NGXLogger
  ) {

  }

  getProducts(): Observable<any> {
    const products = [
      { name: 'shoe', price: 15.99 },
      { name: 'shirt', price: 25.99 },
      { name: 'jeans', price: 54.50 }
    ];
    return of(products).pipe(delay(1000));
  }

  getUser(): Observable <any> {

    // const users = [
    //   new User(1337, "superman", "user_avatar", 1, "some@test.ts", "homepage.com", "GER", "BLN", "01337", "ONLINE", new UserSettings())
    // ];
    // return of(users).pipe(delay(1000));
//  ^^ works with for let user of users


    const user = new User(1337, "superman", "user_avatar", 1, "some@test.ts", "homepage.com", "GER", "BLN", "01337", "ONLINE", new UserSettings());
    return of(this.userService.getUserForComponent()).pipe(delay(1000));

    this.logger.info(this.log_prefix, "get user called");
    // let resolvedUserObservable = new Observable<User>(observer => {
    //   if(this.userService.haveValidUserSession() === true){
    //     this.userService.getCurrentUserWithUserSession().subscribe(user => {
    //       observer.next(user);
    //     })
    //   } else {
    //     this.userService.createUserSessionFromToken().subscribe(haveValidSessionFromCookie =>{
    //       this.logger.info(this.log_prefix, "user service reported cookie token can be used for session:",haveValidSessionFromCookie)
    //       if(haveValidSessionFromCookie === true){
    //         this.logger.info(this.log_prefix, "cookie contains valid token")
    //         this.userService.getCurrentUserWithUserSession().subscribe(user => {
    //           this.logger.info(this.log_prefix, "got user via user session from service:",user);
    //           observer.next(user);
    //         })
    //       } else {
    //         this.logger.info(this.log_prefix, "could not create session from cookie")
    //       }
    //     });
    //   }
    // });
    // return resolvedUserObservable;

    // if(this.userService.haveValidUserSession() === true){
    //   this.userService.getCurrentUserWithUserSession().subscribe(user => {
    //     return Observable.of(user);
    //   })
    // } else {
    //   this.userService.createUserSessionFromToken().subscribe(haveValidSessionFromCookie =>{
    //     this.logger.info(this.log_prefix, "user service reported cookie token can be used for session:",haveValidSessionFromCookie)
    //     if(haveValidSessionFromCookie === true){
    //       this.logger.info(this.log_prefix, "cookie contains valid token")
    //       this.userService.getCurrentUserWithUserSession().subscribe(user => {
    //         this.logger.info(this.log_prefix, "got user via user session from service:",user);
    //         return Observable.of(user);
    //       })
    //     } else {
    //       this.logger.info(this.log_prefix, "could not create session from cookie")
    //     }
    //   });
    // }

  }
}